module.exports = __webpack_public_path__ + "static/img/empty.847f8217.png";